/*
    usePalette
    ---
    Provides color palette inheritance to components that require dynamic palette control. 
    Generally, the palette will automatically cascade to child components using CSS var().
    Only use this composable if you need to manually handle the palette inheritance update.
*/

import { computed, provide, inject } from 'vue';

const paletteProps = () => {
    return {
        // Palette: 'lightmode' or 'darkmode'
        palette: {
            type: String,
            default: null,
        },
    };
};

function usePalette(props) {
    const palette = computed(() => {
        return props.palette;
    });

    provide('ancestorPalette', palette);
    const ancestorPalette = inject('ancestorPalette', 'default-palette');

    const colorPalette = computed(() => {
        return palette.value || ancestorPalette.value || 'default-palette';
    });

    return { colorPalette, ancestorPalette };
}

export { usePalette as default, usePalette, paletteProps };
